import angular from 'angular';
import assistantAdviserSelect from './assistantAdviserSelect';

export default angular
  .module('components.assistantAdviserSelect', [])
  .component('assistantAdviserSelect', assistantAdviserSelect).name;
